<template>
  <b-modal v-model="vModel" size="lg" hide-footer title="Demande de réception">
    <!-- Demandeur -->
    <div
      v-if="
        (userConnected.roles.includes('ROLE_DEMANDEUR') &&
          request.state.id == 4) ||
          (userConnected.roles.includes('ROLE_DEMANDEUR') &&
            request.state.id == 12) ||
          (userConnected.roles.includes('ROLE_ADMIN') &&
            request.state.id == 4) ||
          (userConnected.roles.includes('ROLE_ADMIN') && request.state.id == 12)
      "
    >
      <div class="info-reception">
        <b-row>
          <b-col
            lg="12"
            md="12"
            sm="12"
            cols="12"
            style="font-weight:500;font-size:16px;"
          >
            <font-awesome-icon
              icon="info-circle"
              class="mr-2"
              size="lg"
            ></font-awesome-icon>
            La réception se fait par photos ou rendez-vous selon les types de
            travaux.
          </b-col>
        </b-row>
      </div>
      <b-form-group class="reception-group">
        <b-form-radio-group
          v-model="receptionSelected.option"
          name="radio-options-reception"
        >
          <b-row>
            <b-col lg="4" md="4" sm="4" cols="12"
              ><b-form-radio value="Photos"
                >Travaux types branchements, ATU, mise à la côte, ... <br />(Par
                photos)</b-form-radio
              ></b-col
            >
            <b-col lg="3" md="3" sm="3" cols="12"></b-col>
            <b-col lg="4" md="4" sm="4" cols="12"
              ><b-form-radio value="Rendez-vous"
                >Travaux types enfouissement, extension, ... <br />(Par
                rendez-vous)</b-form-radio
              ></b-col
            >
          </b-row>
        </b-form-radio-group>
      </b-form-group>

      <b-row>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label">Plans de recollement :</label>
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece1.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, application/pdf, image/png"
          ></b-form-file>
        </b-col>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label">Résultats compactage :</label>
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece2.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, application/pdf, image/png"
          ></b-form-file>
        </b-col>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label"
            >Photo
            <span v-if="receptionSelected.option == 'Photos'" class="red"
              >*</span
            >:</label
          >
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece3.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, image/png, application/pdf"
          ></b-form-file>
        </b-col>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label"
            >Photo supplémentaire
            <span v-if="receptionSelected.option == 'Photos'" class="red"
              >*</span
            >:</label
          >
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece4.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, image/png, application/pdf"
          ></b-form-file>
        </b-col>
      </b-row>
      <div v-if="receptionSelected.option == 'Photos'">
        <b-row>
          <b-col lg="4" md="12" sm="12" cols="12">
            <label>Partie du domaine public :</label>
          </b-col>
          <b-col lg="8" md="12" sm="12" cols="12">
            <b-form-checkbox-group
              v-model="receptionSelected.partieDomainePublic"
              :options="typeDomainePublic"
              name="partie du domaine public"
            ></b-form-checkbox-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div
      v-if="
        userConnected.roles.includes('ROLE_INSTRUCTEUR') &&
          request.state.id == 6
      "
    >
      <div
        v-for="document in request.documents"
        v-if="document.typeDocument.nature === 'réception'"
      >
        <div class="line-document">
          {{ document.typeDocument.name }}
          <span class="action"
            ><font-awesome-icon icon="eye" @click="open(document)"
          /></span>
        </div>
      </div>
    </div>

    <div
      v-if="
        userConnected.roles.includes('ROLE_DEMANDEUR') &&
          request.state.id == 7 &&
          reception.option === 'Photos'
      "
    >
      <b-row>
        <b-col lg="3" md="12" sm="12" cols="12">
          <label>Partie du domaine public :</label>
        </b-col>
        <b-col lg="8" md="12" sm="12" cols="12">
          <b>{{
            reception.partieDomainePublic
              ? reception.partieDomainePublic.join(", ")
              : ""
          }}</b>
        </b-col>
      </b-row>
    </div>

    <div v-if="reception.option === 'Rendez-vous'">
      <b-row
        v-if="
          (userConnected.roles.includes('ROLE_INSTRUCTEUR') &&
            request.state.id == 6 &&
            reception.acceptRdv == null &&
            reception.rdv1 == null) ||
            (userConnected.roles.includes('ROLE_ADMIN') &&
              request.state.id == 6 &&
              reception.acceptRdv == null &&
              reception.rdv1 == null)
        "
      >
        <b-col lg="4" md="4" sm="12" cols="12">
          <label>Proposition 1 :</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <label>Proposition 2 :</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <label>Proposition 3 :</label>
        </b-col>
        <b-col lg="4" md="6" sm="12" cols="12">
          <!-- <b-form-datepicker :start-weekday="1" locale="fr" dark hide-header v-model="receptionSelected.rdv1"
                        placeholder="Selectionnez une date"></b-form-datepicker> -->
          <b-form-input
            type="datetime-local"
            v-model="receptionSelected.rdv1"
            placeholder="Selectionnez une date"
          />
          <!-- <b-form-timepicker v-model="receptionSelected.rdv1hour" dark hide-header placeholder="Selectionnez une heure" locale="fr"></b-form-timepicker> -->
        </b-col>
        <b-col lg="4" md="6" sm="12" cols="12">
          <b-form-input
            type="datetime-local"
            v-model="receptionSelected.rdv2"
            placeholder="Selectionnez une date"
          />
          <!-- <b-form-datepicker :start-weekday="1" locale="fr" dark hide-header v-model="receptionSelected.rdv2"
                        placeholder="Selectionnez une date"></b-form-datepicker>
                        <b-form-timepicker v-model="receptionSelected.rdv2hour" hide-header placeholder="Selectionnez une heure" locale="fr"></b-form-timepicker> -->
        </b-col>
        <b-col lg="4" md="6" sm="12" cols="12">
          <b-form-input
            type="datetime-local"
            v-model="receptionSelected.rdv3"
            placeholder="Selectionnez une date"
          />
          <!-- <b-form-datepicker :start-weekday="1" locale="fr" dark hide-header v-model="receptionSelected.rdv3"
                        placeholder="Selectionnez une date"></b-form-datepicker>
                        <b-form-timepicker v-model="receptionSelected.rdv3hour" hide-header placeholder="Selectionnez une heure" locale="fr"></b-form-timepicker> -->
        </b-col>
      </b-row>
      <b-row
        v-if="
          (userConnected.roles.includes('ROLE_INSTRUCTEUR') &&
            request.state.id == 6 &&
            reception.acceptRdv == null &&
            reception.rdv1 != null) ||
            (userConnected.roles.includes('ROLE_ADMIN') &&
              request.state.id == 6 &&
              reception.acceptRdv == null &&
              reception.rdv1 != null)
        "
      >
        <b-col lg="4" md="6" sm="12" cols="12" v-if="reception.rdv1">
          <b-form-input
            type="datetime-local"
            disabled
            v-model="reception.rdv1"
          />
        </b-col>
        <b-col lg="4" md="6" sm="12" cols="12" v-if="reception.rdv2">
          <b-form-input
            type="datetime-local"
            disabled
            v-model="reception.rdv2"
          />
        </b-col>
        <b-col lg="4" md="6" sm="12" cols="12" v-if="reception.rdv3">
          <b-form-input
            type="datetime-local"
            disabled
            v-model="reception.rdv3"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="
          (userConnected.roles.includes('ROLE_DEMANDEUR') &&
            request.state.id == 6 &&
            reception.acceptRdv == null) ||
            (userConnected.roles.includes('ROLE_ADMIN') &&
              request.state.id == 6 &&
              reception.acceptRdv == null)
        "
      >
        <b-col lg="12" md="12" sm="12" cols="12" v-if="reception.rdv1">
          <div class="mb-3">
            <label
              ><font-awesome-icon icon="info-circle" /> Choisissez un
              rendez-vous.
              <br />
              Si vous choissisez
              <b class="nodispo">Aucune disponibilité</b>
              l'instructeur vous proposera de nouvelles dates de rendez-vous.
            </label>
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="12" cols="12" v-if="reception.rdv1">
          <div
            @click="clickRdv(1)"
            :class="acceptRdv == 1 ? 'prop-rdv active-prop-rdv' : 'prop-rdv'"
          >
            <span>{{ formatDate(reception.rdv1) }}</span>
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="12" cols="12" v-if="reception.rdv2">
          <div
            @click="clickRdv(2)"
            :class="acceptRdv == 2 ? 'prop-rdv active-prop-rdv' : 'prop-rdv'"
          >
            <span>{{ formatDate(reception.rdv2) }}</span>
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="12" cols="12" v-if="reception.rdv3">
          <div
            @click="clickRdv(3)"
            :class="acceptRdv == 3 ? 'prop-rdv active-prop-rdv' : 'prop-rdv'"
          >
            <span>{{ formatDate(reception.rdv3) }}</span>
          </div>
        </b-col>
        <b-col
          lg="3"
          md="4"
          sm="12"
          cols="12"
          v-if="reception.rdv1 || reception.rdv2 || reception.rdv3"
        >
          <div
            @click="clickRdv(4)"
            :class="acceptRdv == 4 ? 'prop-rdv active-prop-rdv' : 'prop-rdv'"
          >
            <span>Aucune disponibilité</span>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col>
        <b-button
          :disabled="isButtonReceptionDisabled"
          @click="validReception()"
          variant="primary"
          block
          class="btn-auto pr-5 pl-5"
        >
          Valider
        </b-button>
      </b-col>
      <b-col lg="6" md="10" sm="12" cols="12"></b-col>
      <b-col>
        <b-button
          @click="vModel = false"
          variant="secondary"
          block
          class="btn-auto pr-5 pl-5"
        >
          Annuler
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";
import Vue from "vue";
export default {
  props: ["value"],
  data() {
    return {
      acceptRdv: false,
      typeDomainePublic: [
        { text: "Chaussée", value: "Chaussée" },
        { text: "Trottoir", value: "Trottoir" },
        { text: "Accotement", value: "Accotement" },
      ],
      receptionSelected: {},
      piece1: {
        file: null,
        typeDocument: {},
      },
      piece2: {
        file: null,
        typeDocument: {},
      },
      piece3: {
        file: null,
        typeDocument: {},
      },
      piece4: {
        file: null,
        typeDocument: {},
      },
      piece5: {
        file: null,
        typeDocument: {},
      },
      imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
      pdfMimeType: ["application/pdf"],
      DocMimeType: [
        "application/octet-stream",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "pplication/vnd.oasis.opendocument.text",
        "application/vnd.ms-powerpoint",
        "text/csv",
        "application/vnd.ms-office",
        "text/plain",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ],
    };
  },

  async mounted() {
    // if (
    //   this.request.state.id == 6 ||
    //   this.request.state.id == 7 ||
    //   this.request.state.id == 2
    // ) {
    //   await this.getReception(this.request.id);
    // }
  },
  methods: {
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
        viewer.show();
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
      }
    },
    clickRdv(rdv) {
      this.acceptRdv = rdv;
      switch (rdv) {
        case 1:
          this.receptionSelected.acceptRdv = this.reception.rdv1;
          break;
        case 2:
          this.receptionSelected.acceptRdv = this.reception.rdv2;
          break;
        case 3:
          this.receptionSelected.acceptRdv = this.reception.rdv3;
          break;
        case 4:
          this.receptionSelected.acceptRdv = null;
          this.receptionSelected.rdv1 = null;
          this.receptionSelected.rdv2 = null;
          this.receptionSelected.rdv3 = null;
          break;
      }
    },
    formatDate(date) {
      const dateObject = new Date(date);
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return dateObject.toLocaleDateString("fr-FR", options);
    },
    newReception(data) {
      data.requestId = this.request.id;
      if (this.receptionSelected.option == "Photos") {
        data.stateId = 7;
      } else {
        data.stateId = 6;
      }
      
      if (this.reception.requestId || this.request.state.id == 7) {
        if (this.receptionSelected.acceptRdv === null) {
          data.stateId = 6;
          Vue.prototype.$awn.info("Refus de rendez-vous effectué.");
        } else if (this.receptionSelected.acceptRdv) {
          data.stateId = 7;
          data.acceptRdv = this.receptionSelected.acceptRdv;
          Vue.prototype.$awn.info("Rendez-vous accepté.");
        } else if (
          this.receptionSelected.rdv1 ||
          this.receptionSelected.rdv2 ||
          this.receptionSelected.rdv3
        ) {
          Vue.prototype.$awn.info("Proposition de rendez-vous effectuée.");
        }
        this.updateReception(data);

      } else if (this.request.state.id == 4 || this.request.state.id == 12) {
        if (this.request.state.id == 12) {
          if (this.receptionSelected.option === "Photos") {
            data.stateId = 7;
          }
          data.exState = 12;
        }

        const pieces = [this.piece1, this.piece2, this.piece3, this.piece4];

        for (const piece of pieces) {
          if (piece.file !== null) {
            piece.file.requestId = this.request.id;
            piece.file.stdUserId = this.userConnected.id;

            switch (piece) {
              case this.piece1:
                piece.file.typeDocumentId = 102;
                break;
              case this.piece2:
                piece.file.typeDocumentId = 103;
                break;
              case this.piece3:
                piece.file.typeDocumentId = 104;
                break;
              case this.piece4:
                piece.file.typeDocumentId = 105;
                break;
            }

            this.sendDocument(piece.file);
          }
        }
        // console.log("ADD");
        this.addReception(data);
      }
    },
    validReception() {
      this.vModel = false;
      this.newReception(this.receptionSelected);
    },
    ...Vuex.mapActions("Cerfa", ["setCerfa14023", "updateCerfa14023"]),
    ...Vuex.mapActions("Document", ["sendDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
      "sendToClicmap",
    ]),
  },
  computed: {
    isButtonReceptionDisabled() {
      let disabled = true;

      const demandeur = this.userConnected.roles.includes("ROLE_DEMANDEUR");
      const instructeur = this.userConnected.roles.includes("ROLE_INSTRUCTEUR");
      const admin = this.userConnected.roles.includes("ROLE_ADMIN");

      if (
        (demandeur &&
          this.request.state.id == 4 &&
          this.receptionSelected.option != null) ||
        (demandeur &&
          this.request.state.id == 12 &&
          this.receptionSelected.option != null)
      ) {
        if (this.receptionSelected.option == "Photos") {
          if (this.piece3.file != null && this.piece4.file != null) {
            disabled = false;
          }
        } else {
          disabled = false;
        }
      }
      if (
        (demandeur &&
          this.request.state.id == 6 &&
          this.reception.rdv1 != null) ||
        (demandeur &&
          this.request.state.id == 6 &&
          this.reception.rdv2 != null) ||
        (demandeur && this.request.state.id == 6 && this.reception.rdv3 != null)
      ) {
        disabled = false;
      }
      if (
        (instructeur &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv1 != null) ||
        (instructeur &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv2 != null) ||
        (instructeur &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv3 != null)
      ) {
        disabled = false;
      }

      // ADMIN
      if (
        (admin &&
          this.request.state.id == 4 &&
          this.receptionSelected.option != null) ||
        (admin &&
          this.request.state.id == 12 &&
          this.receptionSelected.option != null)
      ) {
        disabled = false;
      }
      if (
        (admin && this.request.state.id == 6 && this.reception.rdv1 != null) ||
        (admin && this.request.state.id == 6 && this.reception.rdv2 != null) ||
        (admin && this.request.state.id == 6 && this.reception.rdv3 != null)
      ) {
        disabled = false;
      }
      if (
        (admin &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv1 != null) ||
        (admin &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv2 != null) ||
        (admin &&
          this.request.state.id == 6 &&
          this.receptionSelected.rdv3 != null)
      ) {
        disabled = false;
      }
      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },

    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>
